"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Context = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../../../util/helpers");

var _hooks = require("../../../util/hooks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Context = /*#__PURE__*/(0, _react.createContext)();
exports.Context = Context;

var CheckboxContext = function CheckboxContext(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      onChecked = _ref.onChecked,
      onCheckedAll = _ref.onCheckedAll;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      checkboxList = _useState2[0],
      setCheckboxList = _useState2[1];

  var checkboxIds = (0, _react.useRef)([]);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      checkAllValue = _useState4[0],
      setCheckAll = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      checkedIds = _useState6[0],
      setCheckedIds = _useState6[1];

  var onNewCheck = function onNewCheck(key, setChecked, id, checked, disabled) {
    setCheckboxList(function (prevList) {
      return _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, {
        setChecked: setChecked,
        id: id,
        checked: checked,
        disabled: disabled
      }));
    });

    if (checked) {
      if (!checkAllValue) setCheckAll(checked);
      setCheckedIds(function (prevIds) {
        if (!prevIds.includes(id)) {
          return [].concat(_toConsumableArray(prevIds), [id]);
        }

        return prevIds;
      });
    }

    checkboxIds.current.push(id);
  };

  var onRemoveCheck = function onRemoveCheck(key) {
    setCheckboxList(function (prevList) {
      checkboxIds.current = checkboxIds.current.filter(function (i) {
        return i !== prevList[key].id;
      });
      return (0, _helpers.removeFromObject)(prevList, key);
    });
  };

  var notifyContext = function notifyContext(id, checked, key) {
    onChange && onChange({
      id: id,
      checked: checked,
      index: key
    });
    setCheckboxList(function (prevList) {
      var newList = _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, prevList[key]), {}, {
        checked: checked,
        id: id
      })));

      var onlyCheckIds = Object.values(newList).filter(function (v) {
        return v.checked;
      }).map(function (v) {
        return v.id;
      });
      setCheckAll(onlyCheckIds.length > 0);
      setCheckedIds(onlyCheckIds);
      return newList;
    });
  };

  var onReorderChecks = function onReorderChecks(id, key) {
    setCheckboxList(function (prevList) {
      var checked = checkedIds.includes(id);

      if (prevList[key] && prevList[key].setChecked) {
        prevList[key].setChecked(checked);
        return _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, prevList[key]), {}, {
          checked: checked,
          id: id
        })));
      }

      return _objectSpread({}, prevList);
    });
  };

  var onCheckAll = function onCheckAll(flag) {
    var copy = _objectSpread({}, checkboxList);

    var onlyCheckIds = [];
    setCheckAll(flag);
    Object.keys(copy).forEach(function (key) {
      if (!copy[key].disabled) {
        copy[key].checked = flag;
        copy[key].setChecked(flag);
        flag && onlyCheckIds.push(copy[key].id);
      } else {
        copy[key].checked && onlyCheckIds.push(copy[key].id);
      }
    });
    setCheckedIds(onlyCheckIds);
    setCheckboxList(copy);
    onCheckedAll && onCheckedAll(flag);
  };

  (0, _react.useEffect)(function () {
    var onlyChecked = _toConsumableArray(checkedIds);

    if (onlyChecked.length > 0) {
      var checks = [];
      Object.keys(checkboxList).forEach(function (key) {
        checks.push(checkboxList[key].id);
      });
      onlyChecked = onlyChecked.filter(function (v) {
        return checks.includes(v);
      });
      setCheckedIds(onlyChecked);
      setCheckAll(onlyChecked.length > 0);
    }
  }, [Object.keys(checkboxList).length]);
  (0, _hooks.useUpdateEffect)(function () {
    onChecked && onChecked(checkedIds);
  }, [checkedIds]);

  var onDisabledCheck = function onDisabledCheck(key, disabled) {
    if (disabled !== undefined) {
      setCheckboxList(function (prevList) {
        return _objectSpread(_objectSpread({}, prevList), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, prevList[key]), {}, {
          disabled: disabled
        })));
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
    value: [onNewCheck, onRemoveCheck, notifyContext, onCheckAll, onReorderChecks, checkAllValue, checkedIds, onDisabledCheck, checkboxIds.current]
  }, children);
};

CheckboxContext.propTypes = {
  onChecked: _propTypes["default"].func,
  // returns all checked=true items
  //if onChange or onCheckedAll is define, u need to implement ur own logic. Storie name: custom
  onChange: _propTypes["default"].func,
  // return the last item checked true or false.
  onCheckedAll: _propTypes["default"].func //dispatch when CheckAll component change

};
CheckboxContext.defaultProps = {
  onChange: undefined,
  onChecked: undefined,
  onCheckedAll: undefined
};
var _default = CheckboxContext;
exports["default"] = _default;